import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { BELTS, findBelt } from "./cardsData";
import MemberCard from "./memberCard";
import CardLightbox from "./cardLightbox";
import { Dots } from "../Loader/loader";

const BELT_KEYS = BELTS.map((b) => b.key);

const Cards = () => {
  const { user, attachCard, cancelCardRequest } = useAuth();
  const [pending, setPending] = useState(null);
  const [error, setError] = useState("");
  const [viewIndex, setViewIndex] = useState(null);

  const handleAttach = async (belt) => {
    setError("");
    setPending(belt);
    try {
      await attachCard(belt);
    } catch (err) {
      setError(
        err.response?.data?.errors?.belt?.[0] || "Չհաջողվեց ուղարկել հայտը։ Փորձեք կրկին։"
      );
    } finally {
      setPending(null);
    }
  };

  const handleCancel = async () => {
    setError("");
    try {
      await cancelCardRequest();
    } catch {
      setError("Չհաջողվեց չեղարկել հայտը։");
    }
  };

  const attached = findBelt(user.belt || "white");
  const requested = user.belt_request ? findBelt(user.belt_request.belt) : null;

  return (
    <div className="account-panel">
      <h2 className="account-title">Քարտեր</h2>
      {error && <div className="auth-alert">{error}</div>}

      <h3 className="account-subtitle">Կցված քարտ</h3>
      <div className="account-card-preview">
        <MemberCard
          belt={attached.key}
          user={user}
          onClick={() => setViewIndex(BELT_KEYS.indexOf(attached.key))}
        />
        <p className="auth-muted">Գոտի՝ {attached.label}</p>
      </div>

      {requested && (
        <div className="auth-alert info">
          Սպասում է հաստատման՝ <b>{requested.label}</b> քարտ։{" "}
          <button type="button" className="link-btn" onClick={handleCancel}>
            Չեղարկել
          </button>
        </div>
      )}
      <p className="auth-muted">
        Նոր քարտը կցվում է միայն մարզչի կամ ադմինի հաստատումից հետո։
        {!user.trainer && " Մարզիչ ընտրված չէ՝ հայտը կքննի ադմինը։"}
      </p>

      <h3 className="account-subtitle">Բոլոր քարտերը</h3>
      <div className="cards-grid">
        {BELTS.map((belt, i) => {
          const isAttached = attached.key === belt.key;
          const isRequested = user.belt_request?.belt === belt.key;
          return (
            <div key={belt.key} className={`cards-item${isAttached ? " attached" : ""}`}>
              <MemberCard belt={belt.key} user={user} onClick={() => setViewIndex(i)} />
              <div className="cards-item-footer">
                <span>{belt.label}</span>
                {isAttached ? (
                  <span className="cards-badge">Կցված է</span>
                ) : isRequested ? (
                  <span className="cards-badge pending">Սպասվում է</span>
                ) : (
                  <button
                    type="button"
                    className="auth-btn outline cards-attach"
                    disabled={pending !== null}
                    onClick={() => handleAttach(belt.key)}
                  >
                    {pending === belt.key ? <Dots /> : "Հայտ"}
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {viewIndex !== null && (
        <CardLightbox
          belts={BELT_KEYS}
          index={viewIndex}
          user={user}
          onClose={() => setViewIndex(null)}
          onChange={setViewIndex}
        />
      )}
    </div>
  );
};

export default Cards;
